// extracted by mini-css-extract-plugin
module.exports = {"trailersWrapper":"uF","trailerHeader":"uG","trailers":"uH","trailer":"uI","imgWrapper":"uJ","playWrapper":"uK","playImg":"uL","title":"uM","slipnslideArrow":"uN"};